import { render, staticRenderFns } from "./IcoSkillsDomainHealth.vue?vue&type=template&id=68d98d66"
import script from "./IcoSkillsDomainHealth.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports